import React, { ReactElement, ReactNode } from 'react';
import { OverlayTrigger, Popover, PopoverContent, PopoverTitle } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import { OverlayTriggerRenderProps } from 'react-bootstrap/OverlayTrigger';

interface Props {
    title: string;
    content: ReactNode;
    icon: ReactElement | ((props: OverlayTriggerRenderProps) => ReactNode);
}

const ChangeIcon: React.FC<Props> = ({ title, content, icon }) => (
    <OverlayTrigger
        trigger={['hover', 'focus']}
        delay={undefined}
        show={undefined}
        defaultShow={undefined}
        onToggle={undefined}
        flip={undefined}
        overlay={
            <Popover id={uuidv4()}>
                <PopoverTitle as="h5">{title}</PopoverTitle>
                <PopoverContent>{content}</PopoverContent>
            </Popover>
        }
        popperConfig={undefined}
        target={undefined}
        onHide={undefined}
        placement="top"
        transition={false}
    >
        {icon}
    </OverlayTrigger>
);

export default ChangeIcon;
